import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import RouteBloc from "../../../bloc/route_bloc";
import App_header from "../../component/app_header/app_header";
import App_sidebar from "../../component/app_sidebar_mrtt/app_sidebar";
import Config from "../../../Config";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import "./mrtt_proposal_screen.css";
import { setFilterBy } from "../../../data/redux/reducers/filterReducer";
import BaseScreen from "../base/base_screen/base_screen";
import App_header_title_simple from "../../component/app_header_title/app_header_title_simple";
import App_daterange_filter from "../../component/app_filters/app_daterange_filter";
import App_dropdown_filter from "../../component/app_filters/app_dropdown_filter";
import { ReactComponent as PlusIcon } from "../../../Plus.svg";
import { ReactComponent as LeftArrowIcon } from "../../../Arrow_Left.svg";
import { ReactComponent as RightArrowIcon } from "../../../Arrow_Right.svg";
import { ReactComponent as ThreeDotsIcon } from "../../../ThreeDots.svg";
import { Dropdown, Menu, Pagination } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";
import AppDropdownFilter3 from "../../component/app_filters/app_dropdown_filter3";
import AppDropdownSort from "../../component/app_filters/app_dropdown_sort";
import AppQuotationCard from "../../component/app_quotation_card/app_quotation_card";
import App_table from "../../component/app_table/app_table";
import AppModal from "../../component/app_modal/app_modal";
import AppCardStatus from "../../component/app_card_status/app_card_status";
import UserAccessBloc from "../../../bloc/user_access_bloc";
import { Button } from "reactstrap";
import moment from "moment";
import AppSearchFilter2 from "../../component/app_filters/app_search_filter2";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";

const MenulistIcon = (color) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 6H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" fill={color.color} />
      <path d="M5 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H5C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" fill={color.color} />
      <path d="M19 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13Z" fill={color.color} />
    </svg>
  )
}

const GridIcon = (color) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.20779 2H9.4026C10.6219 2 11.6104 2.98846 11.6104 4.20779V9.4026C11.6104 10.6219 10.6219 11.6104 9.4026 11.6104H4.20779C2.98846 11.6104 2 10.6219 2 9.4026V4.20779C2 2.98846 2.98846 2 4.20779 2ZM4.20779 3.81818C3.99262 3.81818 3.81818 3.99262 3.81818 4.20779V9.4026C3.81818 9.61777 3.99262 9.79221 4.20779 9.79221H9.4026C9.61777 9.79221 9.79221 9.61777 9.79221 9.4026V4.20779C9.79221 3.99262 9.61777 3.81818 9.4026 3.81818H4.20779ZM14.5974 12.3896H19.7922C21.0115 12.3896 22 13.3781 22 14.5974V19.7922C22 21.0115 21.0115 22 19.7922 22H14.5974C13.3781 22 12.3896 21.0115 12.3896 19.7922V14.5974C12.3896 13.3781 13.3781 12.3896 14.5974 12.3896ZM14.5974 14.2078C14.3822 14.2078 14.2078 14.3822 14.2078 14.5974V19.7922C14.2078 20.0074 14.3822 20.1818 14.5974 20.1818H19.7922C20.0074 20.1818 20.1818 20.0074 20.1818 19.7922V14.5974C20.1818 14.3822 20.0074 14.2078 19.7922 14.2078H14.5974ZM14.5974 2H19.7922C21.0115 2 22 2.98846 22 4.20779V9.4026C22 10.6219 21.0115 11.6104 19.7922 11.6104H14.5974C13.3781 11.6104 12.3896 10.6219 12.3896 9.4026V4.20779C12.3896 2.98846 13.3781 2 14.5974 2ZM14.5974 3.81818C14.3822 3.81818 14.2078 3.99262 14.2078 4.20779V9.4026C14.2078 9.61777 14.3822 9.79221 14.5974 9.79221H19.7922C20.0074 9.79221 20.1818 9.61777 20.1818 9.4026V4.20779C20.1818 3.99262 20.0074 3.81818 19.7922 3.81818H14.5974ZM4.20779 12.3896H9.4026C10.6219 12.3896 11.6104 13.3781 11.6104 14.5974V19.7922C11.6104 21.0115 10.6219 22 9.4026 22H4.20779C2.98846 22 2 21.0115 2 19.7922V14.5974C2 13.3781 2.98846 12.3896 4.20779 12.3896ZM4.20779 14.2078C3.99262 14.2078 3.81818 14.3822 3.81818 14.5974V19.7922C3.81818 20.0074 3.99262 20.1818 4.20779 20.1818H9.4026C9.61777 20.1818 9.79221 20.0074 9.79221 19.7922V14.5974C9.79221 14.3822 9.61777 14.2078 9.4026 14.2078H4.20779Z" fill={color.color} />
    </svg>
  )
}


class ProposalScreen extends Component {
  constructor(props) {
    super(props);
    let routeParams = RouteBloc.extractRouteParamsFromProps(props);
    this.state = {
      loading: false,
      route: routeParams,
      client: Config.context,
      userData: null,
      placeholderOverview: this.props.dateFilterGlobal?.overallDateValue
        ? this.props.dateFilterGlobal.overallDateValue
        : "",
      fromDate: '2000-01-01',
      toDate: new Date(),
      sortingCriteria: 'cms_createdOn',
      filterCriteriaSetting: '',
      sortingCriteriaOptions: {
        captions: ['Creation Date', 'Last Updated'],
        values: ['cms_createdOn', 'cms_updatedOn'],
        default: 'Creation Date',
        defaultPlaceholder: 'Creation Date'
      },
      sortOrder: 'DESC',
      displayType: 'grid',
      sortOptions: [
        {
          captions: 'Recent - Oldest',
          values: 'DESC',
        },
        {
          captions: 'Oldest - Recent',
          values: 'ASC'
        },
      ],
      selectedStatus: this.props.match.params.status || 'ALL',
      keyword: '',
      proposalList: '',
      proposalAllCount: null,
      proposalDraftCount: null,
      proposalPendingReviewCount: null,
      proposalPendingSubmissionCount: null,
      proposalSubmittedCount: null,
      initiatedStatus: false,
      currentPage: 1,
      totalPage: 0,
      limitItem: 0,
      startItem: 0,
      endItem: 0,
      selectedProposalId: null,
      isDeleteModalOpen: false,
      isModalOpen: false,
    };
  }


  componentDidMount() {
    this.getDateRangeFilter();
    this.getUserData();
    this.getProposalCount();
    this.getProposalList();
  }

  async getUserData() {
    let userData = await UserAccessBloc.getUserData();
    this.setState({ userData: userData });
  }

  async getProposalList() {
    this.setState({ loading: true });
    let userData = await UserAccessBloc.getUserData();
    let sourceChannel = await this.getSelectedBank();
    let listArr = [];
    let proposalDataList = await ProposalBloc.getListingData(
      userData.username,
      // 'SHA002',
      'proposal',
      this.state.sortingCriteria,
      this.state.sortOrder,
      moment(this.state.fromDate).format('YYYY-MM-DD HH:SS:MM'),
      moment(this.state.toDate).format('YYYY-MM-DD 23:59:59'),
      (this.state.selectedStatus != 'SUBMITTED' && this.state.selectedStatus != 'PENDING') ? 'ALL' : this.state.selectedStatus,
      this.state.currentPage - 1 || 0,
      this.state.keyword || '',
      sourceChannel
    )
    if (proposalDataList) {
      proposalDataList.data.map((item) => {
        let quotation = {
          quotationId: item.quotation.id
        }
        let data = Object.assign(item.proposal, quotation);
        listArr.push(data);
      })
      this.setState({
        proposalList: listArr,
        totalPage: proposalDataList.page?.pageCount || 0,
        totalItem: proposalDataList.page?.total || 0,
        limitItem: proposalDataList.page?.limit || 0,
        startItem: (proposalDataList.page?.start || 0) + 1,
        endItem: (proposalDataList.page?.end || 0) + 1
      })
    }
    this.setState({ loading: false });
  }

  async getSelectedBank() {
    return await JSON.parse(sessionStorage.getItem("selectedBank"))?.id || this.props?.userGlobal?.roles[0]?.entity;
  }

  async getProposalCount() {
    this.setState({ loading: true });
    let userData = await UserAccessBloc.getUserData();
    let sourceChannel = await this.getSelectedBank();
    let dataListingCount = await ProposalBloc.getListingCountData(
      userData.username,
      // 'SHA002',
      'proposal',
      this.state.dateFilter,
      moment(this.state.fromDate).format('YYYY-MM-DD HH:SS:MM'),
      moment(this.state.toDate).format('YYYY-MM-DD 23:59:59'),
      sourceChannel
    );
    if (dataListingCount) {
      this.setState({
        proposalAllCount: dataListingCount.data.all,
        proposalDraftCount: dataListingCount.data.draft,
        proposalPendingReviewCount: dataListingCount.data.pendingReview,
        proposalPendingSubmissionCount: dataListingCount.data.pendingSubmission,
        proposalSubmittedCount: dataListingCount.data.submitted,
      })
    }
    this.setState({ loading: false });
  }

  async handleEditProposal(data) {
    this.setState({ loading: true });
    let userData = UserAccessBloc.getUserData();

    let response = await ProposalBloc.editGeneratedProposal(data.id);
    if (response.success) {
      window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${data.id}`
    } else {
      this.setState({
        isError: true,
        errorMessage: 'This proposal cannot be edit.'
      })
    }
    this.setState({ loading: false });
  }

  async handleDeleteProposal(id) {
    this.setState({ loading: true });
    let response = await ProposalBloc.deleteProposalById(id);
    if (response.success) {
      this.setState({
        isDeleteModalOpen: false
      })
      this.getProposalList()
    } else {
      this.setState({
        isError: true,
        errorMessage: 'Proposal delete failed.'
      })
    }
    this.setState({ loading: false });
  }

  init() {
    // this.setState({ loading: true });
    // this.getProposalCount();
    // this.getProposalList();
  }

  handleGoBackToDashboard = () => {
    return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.home}`
  }

  getFilterStatus() {
    return this.props.match.params.status;
  }

  getDateRangeFilter = () => {
    let dateRangeOverallSetting = {
      captions: ['All Time', 'Last 30 Days', 'Last 60 Days', 'Custom'],
      codes: ['All', '30', '60', 'range'],
      default: 'All',
      defaultPlaceholder: 'All Time'
    }

    this.setState({
      dateRangeOverall: dateRangeOverallSetting,
      dateFilter:
        dateRangeOverallSetting.codes[0] ||
        dateRangeOverallSetting.default,
      placeholderOverview:
        dateRangeOverallSetting.captions[0] ||
        dateRangeOverallSetting.defaultPlaceholder,
    });
  }

  handleFilterDate = (dateValue) => {
    let today = moment();
    let fromDate = '';
    let toDate = '';
    if (dateValue == 'All') {
      fromDate = '2000-01-01'
      toDate = today.format('YYYY-MM-DD')
    } else if (dateValue != "range") {
      fromDate = today.subtract(dateValue, 'day').format('YYYY-MM-DD')
      toDate = moment().format('YYYY-MM-DD')
    }
    this.setState({
      dateFilter: dateValue,
      fromDate: fromDate,
      toDate: toDate,
      currentPage: 1
    }, () => {
      this.getProposalList();
      this.getProposalCount();
    });
  }

  handleDateRange = (dateRange) => {
    if (dateRange) {
      let fromDate = dateRange ? dateRange[0] : null;
      let toDate = dateRange ? dateRange[1] : null;

      this.setState(
        {
          ...this.state,
          fromDate: fromDate,
          toDate: toDate,
          currentPage: 1
        }, () => {
          this.getProposalList();
          this.getProposalCount();
        }
      );
    }
  }

  handleFilterListByStatus = (status) => {
    let currentStatus = this.state.selectedStatus == status ? 'ALL' : status;

    this.setState({ selectedStatus: currentStatus }, () => {
      this.getProposalList();
    });

  }

  handleSortingCriteriaChange = (sort) => {
    this.setState({ sortingCriteria: sort, currentPage: 1 }, () => {
      this.getProposalList();
    });
  }

  handleSortOrderChange = (order) => {
    this.setState({ sortOrder: order, currentPage: 1 }, () => {
      this.getProposalList();
    })
  }

  handleOnClickSearch = () => {
    console.log("searching")
  }

  handleChangeKeyword = (keyword) => {
    this.setState({ keyword: keyword, currentPage: 1 }, () => {
      this.getProposalList();
    })
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.getProposalList();
    });
  }

  handlePrivacyModalOpen = () => {
    this.setState({ isModalOpen: true })
  }

  handlePrivacyModalClose = () => {
    this.setState({ isModalOpen: false })
  }

  handleDeleteModalOpen = () => {
    this.setState({ isDeleteModalOpen: true })
  }

  handleDeleteModalClose = () => {
    this.setState({ isDeleteModalOpen: false })
  }

  async handleCreateNewProposal() {
    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_selection}`;
  }

  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <AppLoadingDialog isLoading={this.state.loading} />
      </div>
    );
  }

  columns = [
    {
      title: 'Ref No.',
      dataIndex: 'refNo',
      key: 'ref',
      //   render: (text) => <a>{text}</a>,
    },
    {
      title: 'Client Name',
      dataIndex: 'fullName',
      key: 'name',
    },
    {
      title: 'ID No.',
      dataIndex: 'idNo',
      key: 'id',
    },
    {
      title: 'Creation Date',
      dataIndex: 'cms_createdOn',
      key: 'createdDate',
      render: (cms_createdOn) => (
        <>{moment(cms_createdOn).format('DD/MM/YYYY')}</>
      ),
    },
    {
      title: 'Last Updated',
      dataIndex: 'cms_updatedOn',
      key: 'lastUpdate',
      render: (cms_updatedOn) => (
        <>{moment(cms_updatedOn).format('DD/MM/YYYY')}</>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'trxStatus',
      render: (_, { trxStatus }) => (
        <AppCardStatus
          status={trxStatus}
          module={"proposal"}
        />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu
              style={{
                marginTop: "12px",
                width: '200px'
              }}
              items={this.getDropDownItem(_, _.trxStatus)}
            />
          }
          trigger={["click"]}
          className="header__profile"
        >
          <Button type="text"
            style={{ backgroundColor: 'transparent', border: '0px', boxShadow: 'none' }}
            onClick={(e) => e.stopPropagation()}>
            <ThreeDotsIcon className="" />
          </Button>
        </Dropdown>

      ),
    },
  ];

  getProposalStatus = (status) => {
    let proposalStatus = ''
    status === 'Proposal Proceeded' ? proposalStatus = 'GENERATED' :
      status === 'Proposal Created' ? proposalStatus = 'PENDING' :
        status === 'Draft' ? proposalStatus = 'DRAFT' :
          proposalStatus = status;

    return proposalStatus;
  }

  handleOnDropDownItemClick = (opt, data) => {

    if (opt === 'Delete Proposal') {
      this.setState({ selectedProposalId: data.id });
      this.handleDeleteModalOpen();
    }
    else if (opt === 'Update Quotation') {
      return (
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${data.id}`
      )
    }
    else if (opt === 'Update Proposal') {
      this.handleEditProposal(data)
    }
    else if (opt === 'View Proposal') {
      return (
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/${data.id}`
      )
    }
    else if (opt === 'View Quotation') {
      return (
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/${data.quotationId}`
      )
    }
  }

  handleViewProposal = (data) => {
    if (data.status == 'DRAFT') {
      this.handleEditProposal(data.id)
    } else {
      window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/${data.id}`
    }

  }

  getDropDownItem = (proposalData, status) => {
    let dropdownitem = Config.proposal.actions[this.getProposalStatus(status)].labels;
    let item = [];
    dropdownitem.map((data, idx) => {
      item.push(
        {
          label: (
            <div
              onClick={() => this.handleOnDropDownItemClick(data, proposalData)}
              className="dropdown_item"
            >
              {data}
            </div>

          ),
          key: idx
        }
      )
    })
    return item;
  }

  renderToolBar = () => {
    return (
      <div className="d-flex">
        <div style={{ width: '21%' }}>
          <App_dropdown_filter
            width={'100%'}
            onSelectedDateFilter={this.handleFilterDate}
            dataDateByCaption={this.state.dateRangeOverall?.captions || []}
            dataDateByValue={this.state.dateRangeOverall?.codes || []}
            placeholder={this.state.placeholderOverview}
          />
        </div>
        <div style={{ width: '21%' }}>
          <App_daterange_filter
            width={'100%'}
            isNotRange={this.state.dateFilter != "range"}
            defaultValueFromDate={this.state.fromDate}
            defaultValueToDate={this.state.toDate}
            value={[this.state.fromDate, this.state.toDate]}
            disabled={this.state.dateFilter == "range" ? false : true}
            onSelectedDateRange={this.handleDateRange}
          />
        </div>
        <div className="ml-2" style={{ width: '13%' }}>
          <AppDropdownFilter3
            options={this.state.sortingCriteriaOptions}
            onSelectedOptions={this.handleSortingCriteriaChange}
            default={this.state.sortingCriteria}
            value={this.state.sortingCriteria}
          />
        </div>
        <div className="ml-2" style={{ width: '15%' }}>
          <AppDropdownSort
            options={this.state.sortOptions}
            onSelectedOptions={this.handleSortOrderChange}
            default={this.state.sortOptions[0].captions}
          />
        </div>
        <div className="ml-2 row" style={{ width: '8%' }}>
          <Button
            className="w-50 proposal_container_border h-100 p-0"
            style={{ backgroundColor: '#FFFFFF', border: '1px solid rgba(224, 224, 224, 1)', borderRadius: 0, boxShadow: 'none' }}
            onClick={() => this.setState({ displayType: 'list' })}
          >
            <MenulistIcon color={this.state.displayType === 'list' ? "#EE7623" : "#92929D"} />
          </Button>
          <Button
            className="w-50 proposal_container_border h-100 p-0"
            style={{ backgroundColor: '#FFFFFF', border: '1px solid rgba(224, 224, 224, 1)', borderRadius: 0, boxShadow: 'none' }}
            onClick={() => this.setState({ displayType: 'grid' })}
          >
            <GridIcon color={this.state.displayType === 'grid' ? "#EE7623" : "#92929D"} />
          </Button>
        </div>
        <div className="ml-2 row" style={{ width: '22%' }}>
          <AppSearchFilter2
            title={"Search by reference number/client name..."}
            onChangeKeyword={this.handleChangeKeyword}
            onClickSearch={this.handleOnClickSearch}
          />
        </div>

      </div>
    )
  }

  renderGridList = () => {
    return (
      <>
        <div className="row px-2" style={{ rowGap: '1%', columnGap: '1%' }}>
          {
            this.state.proposalList && this.state.proposalList.map((data) => {
              return (
                <AppQuotationCard
                  name={data.fullName}
                  id={data.id}
                  quotationId={data.quotationId}
                  status={data.trxStatus}
                  refNo={data.refNo}
                  idNo={data.idNo}
                  data={data}
                  createdDate={moment(data.cms_createdOn).format('DD/MM/YYYY')}
                  lastUpdated={moment(data.cms_updatedOn).format('DD/MM/YYYY')}
                  handleDelete={(id) => this.handleDeleteProposal(id)}
                  handleEditProposal={(id) => this.handleEditProposal(id)}
                  getDropDownItem={(data, status) => this.getDropDownItem(data, status)}
                  props={this.props}
                  module={'proposal'}
                  showMenu={true}
                />
              )
            })
          }
        </div>
        {
          this.state.totalPage > 0 &&
          <div
            style={{ padding: 16 }}
            className="align-items-center d-flex  w-100"
          >
            {/* {this.props.data.length ? ( */}
            <>
              <div style={{ width: "40%" }}>
                {this.state.startItem} -{" "}
                {this.state.endItem} of{" "}
                {
                  (this.state.selectedStatus === 'PENDING') ?
                    (this.state.proposalPendingReviewCount?.page.total + this.state.proposalPendingSubmissionCount?.page.total + this.state.proposalDraftCount?.page.total) :
                    this.state.selectedStatus === Config.proposal.statusMapping.SUBMITTED.label ? this.state.proposalSubmittedCount?.page.total :
                      this.state.proposalAllCount?.page.total
                } items
              </div>
              <div className="d-flex align-items-center">
                <div className="page_title_paggination">Page</div>
                <Pagination
                  current={this.state.currentPage || 1}
                  total={
                    (this.state.selectedStatus === 'PENDING') ?
                      (this.state.proposalPendingReviewCount?.page.total + this.state.proposalPendingSubmissionCount?.page.total + this.state.proposalDraftCount?.page.total) :
                      this.state.selectedStatus === Config.proposal.statusMapping.SUBMITTED.label ? this.state.proposalSubmittedCount?.page.total :
                        this.state.proposalAllCount?.page.total
                  }
                  onChange={(e) => this.handlePageChange(e)}
                  style={{ bottom: "0px", width: "100%" }}
                  nextIcon={<RightArrowIcon />}
                  prevIcon={<LeftArrowIcon />}
                  pageSize={12}
                  pageSizeOptions={[10]}
                  showLessItems
                  size="default"
                />
                <div
                  className="page_total_paggination"
                >
                  of {Math.ceil((
                    (this.state.selectedStatus === 'PENDING') ?
                      (this.state.proposalPendingReviewCount?.page.total + this.state.proposalPendingSubmissionCount?.page.total + this.state.proposalDraftCount?.page.total) :
                      this.state.selectedStatus === Config.proposal.statusMapping.SUBMITTED.label ? this.state.proposalSubmittedCount?.page.total :
                        this.state.proposalAllCount?.page.total
                  ) / 12)}
                </div>
              </div>
              <div></div>
            </>
            {/* ) : null} */}
          </div>
        }

      </>
    )
  }

  renderTableList = () => {
    return (
      <div className="w-100">
        <App_table
          data={this.state.proposalList || ''}
          collumn={this.columns}
          totalData={this.state.selectedStatus === "ALL" ?
            this.state.proposalAllCount?.page.total :
            (this.state.proposalPendingReviewCount?.page.total + this.state.proposalPendingSubmissionCount?.page.total + this.state.proposalDraftCount?.page.total)
          }
          onSelectedPage={this.handlePageChange}
          currentPage={this.state.currentPage}
          handleOnClick={this.handleViewProposal}
          pagination={true}
        />
      </div>
    )
  }

  render() {
    return (
      <>
        <div style={{ fontFamily: 'Lato' }}>
          {this.state.loading && this.loadingContent()}
          {/* <BaseScreen
                        listener={(userSettings) => {
                            this.init();
                        }}
                    > */}
          <App_header
            data={this.state.userData}
            route={this.state.route.entity}
          />
          <App_sidebar route={this.state.route.entity}>
            <div className="row m-0 align-items-center">
              <div className="col-9">
                <App_header_title_simple
                  title="Proposal"
                  handleBack={() => this.handleGoBackToDashboard()}
                />
              </div>
              <div className="col-3 d-flex justify-content-end align-items-center">
                <Button
                  className="d-flex align-items-center proposal_link py-3"
                  type="text"
                  onClick={() => this.handleCreateNewProposal()}
                  style={{
                    backgroundColor: "#183028",
                    padding: '1.5vh',
                    borderRadius: 0,
                    color: '#ffffff',
                  }}
                >
                  <PlusIcon className="mr-2" fill="white" />
                  <span className="proposalscreen_link_text">Create New Proposal</span>
                </Button>
              </div>
            </div>
            <div className="mt-4">
              {this.renderToolBar()}
            </div>
            <div className="proposal_status_container">
              <div
                className={
                  (this.state.selectedStatus === Config.proposal.statusMapping.SUBMITTED.label || this.state.selectedStatus === "ALL") ?
                    "proposal_status_proceeded" : "proposal_status_initiated"
                }
                onClick={() => this.handleFilterListByStatus(Config.proposal.statusMapping.SUBMITTED.label)}
              >
                {this.state.proposalSubmittedCount?.page.total || 0}
                <span className="proposalscreen_text">Submitted </span>
              </div>

              <div
                className={
                  (this.state.selectedStatus === 'PENDING' || this.state.selectedStatus === "ALL") ?
                    "proposal_status_initiated_filter" : "proposal_status_initiated"
                }
                onClick={() => this.handleFilterListByStatus('PENDING')}
              >
                {(this.state.proposalPendingReviewCount?.page.total + this.state.proposalPendingSubmissionCount?.page.total + this.state.proposalDraftCount?.page.total) || 0}
                <span className="proposalscreen_text">Pending</span>
              </div>

            </div>
            <div className="my-3">
              Showing
              <b className="px-1">
                {
                  (this.state.selectedStatus === 'PENDING') ?
                    (this.state.proposalPendingReviewCount?.page.total + this.state.proposalPendingSubmissionCount?.page.total + this.state.proposalDraftCount?.page.total) :
                    this.state.selectedStatus === Config.proposal.statusMapping.SUBMITTED.label ? this.state.proposalSubmittedCount?.page.total :
                      this.state.proposalAllCount?.page.total
                }
              </b> result
            </div>
            {this.state.displayType === 'list' && this.renderTableList()}
            {this.state.displayType === 'grid' && this.renderGridList()}
          </App_sidebar >
          {/* </BaseScreen> */}
        </div >
        <AppModal
          open={this.state.isError}
          closable={false}
          positiveButtonText={'OK'}
          handleModalClose={() => { this.setState({ isError: false }) }}
          handlePositivePress={() => this.setState({ isError: false })}
        >
          <span style={{ fontSize: 20, fontWeight: 500 }}>{this.state.errorMessage}</span>
        </AppModal>
        <AppModal
          open={this.state.isDeleteModalOpen}
          handleModalClose={this.handleDeleteModalClose}
          width={'50%'}
          title={'Do you want to delete this proposal ?'}
          negativeButtonText={'Cancel'}
          positiveButtonText={'Yes, Delete'}
          handleNegativePress={this.handleDeleteModalClose}
          handlePositivePress={() => this.handleDeleteProposal(this.state.selectedProposalId)}
        >
          <span style={{ fontSize: 16, color: '#808EA8' }}>If you delete this proposal, you wil loose any progress you{'\''}ve made.</span>
        </AppModal>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  userGlobal: state.user.value,
  globalFilterBy: state.filter.value,
  globalSearchBy: state.searchBy.value,
});

const mapDispatchToProps = { setFilterBy };

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProposalScreen)
);